import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Edit as EditInterface } from "../../../../interfaces/reservation.interface";
import { VALIDATION_FIELD_MAPPING } from "../../../../utils/appConstant";
import { Modules, RouteParamsTypes } from "../../../../enums";
import Badge from "../../../../components/Badge";

interface FormHeaderProps {
  formData: EditInterface;
  view: boolean;
  external?: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({ formData, view, external }) => {
  const { t } = useTranslation();

  const handleInvoiceClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <div className="d-flex justify-content-between">
      <h5 className={clsx("card-header", external && 'fs-4')}>{view ? t("reservations.edit.pageTexts.title.viewTitle") : t("reservations.edit.pageTexts.title.editTitle")}</h5>

      <div className={clsx("d-flex align-items-center", !external && "p-5", external && "fs-6")}>
        {
          formData.invoiceNo && (
            <span className={clsx("text-primary me-3 fw-bold", !external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleInvoiceClick(formData.invoiceId)}>
              {t("reservations.edit.pageTexts.title.invoiceNo", { invoiceNumber: formData.invoiceNo })}
            </span>
          )
        }

        <Badge
          className={
            clsx(
              "badge rounded-pill px-3 py-2 fw-medium",
              formData.status === VALIDATION_FIELD_MAPPING.unBilled && "bg-secondary text-white",
              formData.status === VALIDATION_FIELD_MAPPING.invoice && "bg-warning text-white",
              formData.status === VALIDATION_FIELD_MAPPING.settled && "bg-info text-white"
            )
          }
          variant="secondary"
          text={formData.statusName || ""}
        />
      </div>
    </div>
  )
}

export default FormHeader;